import { defineStore } from 'pinia'
import { ref } from 'vue'
import {
  adminGetStoreSettings,
  adminUpdateStoreSettings,
  getPublicStoreSettings,
} from '../api'
import { useAuth } from '../auth'
import type { AdminUpdateStoreSettingsParams } from '../api'
import type { StoreSettings } from '../types'

export const useStoreSettingsStore = defineStore('storeSettings', () => {
  const auth = useAuth()
  const settings = ref<StoreSettings | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetchPublic() {
    loading.value = true
    error.value = null
    try {
      settings.value = await getPublicStoreSettings()
      return settings.value
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Failed to load store settings'
      throw e
    } finally {
      loading.value = false
    }
  }

  async function fetchAdmin() {
    loading.value = true
    error.value = null
    try {
      settings.value = await adminGetStoreSettings(auth.getToken())
      return settings.value
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Failed to load store settings'
      throw e
    } finally {
      loading.value = false
    }
  }

  async function update(params: AdminUpdateStoreSettingsParams) {
    loading.value = true
    error.value = null
    try {
      await adminUpdateStoreSettings(params, auth.getToken())
      settings.value = await adminGetStoreSettings(auth.getToken())
      return settings.value
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Failed to save store settings'
      throw e
    } finally {
      loading.value = false
    }
  }

  return { settings, loading, error, fetchPublic, fetchAdmin, update }
})
